<template>
  <main id="watchlist-container">
    <section id="watchlist-section">
      <div class="page-loading" v-if="getLoadingWatchlist">
        <i class="fas fa-spinner-third fa-spin"></i>
      </div>
      <FollowingList v-if="getIslogin" />
      <FollowingAuth v-else />
    </section>
  </main>
</template>

<script>
const FollowingAuth = () => import("../../components/miniapp/following/FollowingAuth");
const FollowingList = () => import("../../components/miniapp/following/FollowingList");
import { mapGetters } from "vuex";
export default {
  metaInfo: {
    title: process.env.VUE_APP_NAME
  },
  components: {
    FollowingAuth,
    FollowingList
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("auth", ["getIslogin"]),
    ...mapGetters("watchlist", ["getLoadingWatchlist"])
  }
};
</script>